module.exports = __webpack_public_path__ + "img/projects.7adc697c.png";